import * as React from "react";
import { WysiwygEditorUnified } from "@/components/wysiwyg-editor-unified";

interface RichTextEditorSectionProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label: string;
  error?: string;
  required?: boolean;
}

/**
 * Rich Text Editor Section Component
 * 
 * This is the unified wrapper component for WYSIWYG editor used throughout the admin app.
 * All rich text editing should use this component for consistency.
 */
export function RichTextEditorSection({
  value,
  onChange,
  placeholder = "Start writing...",
  label,
  error,
  required = false
}: RichTextEditorSectionProps) {
  return (
    <WysiwygEditorUnified
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      label={label}
      error={error}
      required={required}
    />
  );
}